import { Children, cloneElement, useEffect } from 'react';

import { useAgenciesGetQuery } from '../../Common/Queries/agenciesQueries';
import {
  useApplicationsById,
  useApplicationsGetQueryById,
} from '../../Common/Queries/applicationsQueries';
import { usePositionsGetQuery } from '../../Common/Queries/positionsQueries';

import { htmlToMD, isLogin } from '../../utils';

import { ALL_DATA_LIMIT, DURATION_TIME } from '../../constants';

export const formateData = (values) => {
  return {
    reason: htmlToMD(values?.reason),
    id: values?.id,
    name: values?.name,
    position: values?.position,
    agencyId: values?.agencyId,
    email: values?.email,
    phone: `+91${values.phone}`,
    status: values?.status,
    updatedStatus: values?.updatedStatus,
    createdAt: values?.createdAt,
    updatedAt: values?.updatedAt,
    versionKey: values?.versionKey,
    allowedOperations: values?.allowedOperations,
    events: values?.events,
    interview: values?.interview,
    coolingPeriod: values?.coolingPeriod,
    referrer: values?.referrer,
    uploadedBy: values?.uploadedBy,
    recruiter: values?.recruiter,
    agency: values?.agency,
    lastRoundInfo: values?.lastRoundInfo,
    requiredInfo: values?.requiredInfo,
    applicantID: values?.applicantID,
    isUpload: values?.isUpload,
    isReferral: values?.isReferral,
    isCareer: values?.isCareer,
    latestRoundID: values?.latestRoundID,
    orgID: values?.orgID,
    customFormData: values?.customFormData,
    invalidFields: values?.invalidFields,
  };
};

export function EditApplicationContainer(props) {
  const { applicationData: data, applicationId: id, setOpen, children } = props;
  const putToApplication = useApplicationsById();
  const { refetch: refetchApplication } = useApplicationsGetQueryById(id);

  const handleSubmit = (finalValues, customNotice) => {
    const reqBody = formateData(finalValues, customNotice);
    const reqParams = { reqBody, reqId: id };
    putToApplication.mutate(reqParams);
  };

  const positionList = usePositionsGetQuery(
    { limit: ALL_DATA_LIMIT },
    {
      enabled: isLogin(),
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  const agencyList = useAgenciesGetQuery(
    { limit: ALL_DATA_LIMIT },
    {
      enabled: isLogin(),
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  useEffect(() => {
    if (putToApplication.isSuccess) {
      setOpen(false);
      refetchApplication();
    }
  }, [putToApplication.isSuccess]);

  return Children.only(
    cloneElement(children, { data, putToApplication, handleSubmit, positionList, agencyList })
  );
}
